import { addressStatus, addressMessages } from '../constants/address';

export const getAddressNoSuggestionMessage = (status) => {
  switch (status) {
    case addressStatus.UNNECESSARY_UNIT_STATUS:
      return addressMessages.DELIVERABLE_UNNECESSARY_UNIT_MSG;
    case addressStatus.INCORRECT_UNIT_STATUS:
      return addressMessages.DELIVERABLE_INCORRECT_UNIT_MSG;
    case addressStatus.MISSING_UNIT_STATUS:
    case addressStatus.MISSING_INFO_STATUS:
      return addressMessages.DELIVERABLE_MISSING_UNIT_MSG;
    default: return '';
  }
};
